/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import numeral from 'numeral';
import moment from 'moment';

import { formatDollarAmount } from 'services/Formats';

import flow from 'lodash/flow';
import pick from 'lodash/pick';
import reduce from 'lodash/reduce';
import startCase from 'lodash/startCase';

import { DATE_DISPLAY_FORMAT } from 'services/Dates';
import { isActiveAdvisory } from '../Products';

const remapName = (name) => {
  const mapper = {
    accountWChecksum: 'Account Number',
    ownerNames: 'Owner(s)',
    accountType: 'Account Type',
    ticker: 'Account Ticker',
    transactionDescription: 'Transaction Details'
  };

  return mapper[name] || startCase(name);
};

const remapValue = (name, value) => {
  const mapper = {
    ownerNames: (o) =>
      Object.values(o)
        .filter((v) => v)
        .join(', '),
    quantity: (v) => numeral(v).format('0,0.0000'),
    price: formatDollarAmount,
    netDollarAmount: formatDollarAmount,
    tradeDate: (v) => moment.utc(v).format(DATE_DISPLAY_FORMAT)
  };

  return name in mapper ? mapper[name](value) : value;
};

const mapTransaction = flow(
  (o) =>
    pick(
      o,
      'accountType',
      'tradeDate',
      'transactionType',
      'transactionDescription',
      'accountName',
      'ticker',
      'accountWChecksum',
      'owners',
      'netDollarAmount',
      'quantity',
      'price',
      'costBasis'
    ),
  (o) =>
    reduce(
      o,
      (acc, v, k) => ({
        ...acc,
        [remapName(k)]: remapValue(k, v)
      }),
      {}
    )
);

const mapTicker = (transaction) => {
  return {
    ...transaction,
    ticker: isActiveAdvisory(transaction.productType) ? '' : transaction.ticker
  };
};

export const getTransactionsForExport = (transactionHistory = []) => {
  const transactions = transactionHistory.map((t) => mapTicker(t), []);
  return transactions.map((t) => mapTransaction(t), []);
};
